class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

(function () {
  function getCartTotalFromInputs(form) {
    const inputs = form.querySelectorAll('.quantity__input[name="updates[]"]');
    let total = 0;

    inputs.forEach((input) => {
      const val = parseInt(input.value, 10);
      if (!isNaN(val)) total += val;
    });

    return total;
  }

  function updateMinItemsMessage(total, minItems) {
    const msgEl = document.getElementById('CartDrawer-MinItemsMessage');
    if (!msgEl) return;

    if (total < minItems && total > 0) {
      msgEl.textContent =
        `Almost there! You need at least ${minItems} items in your cart before you can proceed to checkout. You currently have ${total} items.`;
    } else if (total === 0) {
      msgEl.textContent = '';
    } else {
      msgEl.textContent = '';
    }
  }
  function updateLargeOrderMessage(total) {
  const el = document.getElementById('CartDrawer-LargeOrderMessage');
  if (!el) return;

  if (total >= 240) {
    el.textContent =
      'Large orders (240+ cans) To keep Cheappouches fair for private customers, large-volume orders are handled separately. Please contact our business team at: wholesale@cheappouch.com';
    el.style.display = '';
  } else {
    el.textContent = '';
    el.style.display = 'none';
  }
}

  function updateCheckoutButtonState() {
  const checkoutButton = document.getElementById('CartDrawer-Checkout');
  const form = document.getElementById('CartDrawer-Form');
  if (!checkoutButton || !form) return;

  const minItems = parseInt(checkoutButton.dataset.minItems || '10', 10);
  const total = getCartTotalFromInputs(form);

  // Disable hvis for få eller hvis 240+
  checkoutButton.disabled = total < minItems || total >= 240;

  updateMinItemsMessage(total, minItems);
  updateLargeOrderMessage(total);
}
  // Når man klikker på checkout
  document.addEventListener('click', function (event) {
    const checkoutButton = event.target.closest('#CartDrawer-Checkout');
    if (!checkoutButton) return;

    const form = document.getElementById('CartDrawer-Form');
    if (!form) return;

    const minItems = parseInt(checkoutButton.dataset.minItems || '10', 10);
    const total = getCartTotalFromInputs(form);

    if (total < minItems) {
      event.preventDefault();
      event.stopPropagation();
      updateMinItemsMessage(total, minItems);
    }
    if (total >= 240) {
  event.preventDefault();
  event.stopPropagation();
  updateLargeOrderMessage(total);
}
  });

  // Når quantity ændres
  document.addEventListener('input', function (event) {
    if (!event.target.matches('.quantity__input[name="updates[]"]')) return;
    updateCheckoutButtonState();
  });

  // Hvis temaet fyrer custom events ved cart-update kan du hooke her
  document.addEventListener('cart:updated', updateCheckoutButtonState);

  // Initial state
  document.addEventListener('DOMContentLoaded', updateCheckoutButtonState);
})();
customElements.define('cart-drawer-items', CartDrawerItems);
